/**
 * Created by Ning Jiang on 2021-06-04.
 */

import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/text/BitmapTextStyleOptions";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {DeadwoodRipGameAssets} from "../DeadwoodRipGameAssets";
import {DeadwoodRip} from "../DeadwoodRip";
import {DeadwoodRipLayers, Layers} from "./DeadwoodRipLayers";
import {DeadwoodRipGameMode} from "../server/DeadwoodRipGameMode";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class Multiplier extends PIXI.Container {

    private readonly _numberStyle:BitmapTextStyleOptions = {
        fontName : DeadwoodRipGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER,
        fontSize : 34,
        tint : 0xffffff
    };

    private _emptyHolder:PIXI.Sprite;
    private _numberText:PIXI.BitmapText;
    // private _numberGlowText:PIXI.BitmapText;
    // private _effectContainer:PIXI.Container;
    // private _isSuper:boolean;

    // private _lastSoundIndex:number;
    // private _lastSoundTime:number;

    private _currentMultiplier:number = 0;
    public get currentMultiplier():number {
        return this._currentMultiplier;
    }

    constructor() {
        super();

        this._emptyHolder = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures("xNudgeLogo")[0]);
        this._emptyHolder.anchor.set(0.5);
        this._emptyHolder.position.set(6, 2);
        this.addChild(this._emptyHolder);

        this._numberText = new PIXI.BitmapText("", this._numberStyle);
        (<PIXI.Point>this._numberText.anchor).set(0.5, 1.36);
        this._numberText.letterSpacing = -36;
        this._numberText.visible = false;
        this.addChild(this._numberText);

        this.position.set(660, 134);
        DeadwoodRipLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(this);

        // this.updateMultiplier(123456, false);
    }

    public updateMultiplier(value:number, animate:boolean):void {
        if(value === this._currentMultiplier) {
            return;
        }

        this._currentMultiplier = value;
        const targetVisible = value > 0;
        this._numberText.text = `x${value.toString()}`;
        // this._numberGlowText.text = `x${value.toString()}`;
        if(value > 0) {
            this._numberText.visible = true;
            // this._numberGlowText.visible = this._isSuper;
            this._emptyHolder.visible = false;
        } else {
            this._numberText.visible = false;
            // this._numberGlowText.visible = false;
            this._emptyHolder.visible = true;
        }
        if(!targetVisible) {
            return;
        }
        this.updateSize(animate);
    }

    private updateSize(animate:boolean):void {
        const landscapeMaxWidth = 120;
        this._numberText.scale.set(1);
        this._numberText.updateTransform();
        const targetScale = this._numberText.textWidth > landscapeMaxWidth ? MathHelper.roundToDecimals(landscapeMaxWidth / this._numberText.textWidth, 2) : 1;
        const tl = gsap.timeline();
        if(animate) {
            tl.add(() => {this._numberText.scale.set(targetScale * 1.2)}, 0);
            // if(this._numberGlowText.visible) {
            //     tl.add([
            //         () => {this._numberGlowText.scale.set(1.2 * 0.44)},
            //         gsap.to(this._numberGlowText.scale, {x : 0.44, y : 0.44, duration : 0.3})
            //     ]);
            // }
        }
        tl.add(gsap.to(this._numberText.scale, {x : targetScale, y : targetScale, duration : 0.3}));
    }

    // public addMultiplier(value:number, log:string):void {
    //     // Logger.logDev(`MULTIPLIER: Adding multiplier from ${log}, old value ${this._currentMultiplier}, new value ${this._currentMultiplier + value}`);
    //     const endValue = this._currentMultiplier + value;
    //     // this.playAddEffects(endValue);
    //     this.updateMultiplier(endValue, true);
    // }

    // private playAddEffects(value:number):void {
    //     if(value < 5) {
    //         return;
    //     }
    //
    //     const now = Date.now();
    //     const soundIndex = this.getSoundIndex(value);
    //     if((now - this._lastSoundTime < 50) && soundIndex === this._lastSoundIndex) {
    //         return;
    //     }
    //
    //     this._lastSoundTime = now;
    //     this._lastSoundIndex = soundIndex;
    //     TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.MULTIPLIER[soundIndex]});
    //     const effect = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("multiplier"));
    //     effect.autoUpdate = true;
    //     this._effectContainer.addChild(effect);
    //     const tween = new SpineTween(effect, 0, "glow");
    //     tween.vars.onComplete = () => SpineHelper.destroySpine(effect);
    // }

    private getSoundIndex(value:number):number {
        if(value < 8) {
            return 0;
        }
        if(value < 11) {
            return 1;
        }
        if(value < 14) {
            return 2;
        }
        if(value < 17) {
            return 3;
        }
        return 4;
    }

    public reset():void {
        // if(this.isSticky(DeadwoodRip.model.data.nextMode)) {
        //     return;
        // }

        this.updateMultiplier(0, false);
    }

    private isSticky(nextMode:string):boolean {
        return nextMode === GameMode.FREESPIN || nextMode === DeadwoodRipGameMode.FREESPIN_SUPER;
    }

    public verifyTotalMultiplier():void {
        if(!NolimitConfig.isDevMode) {
            return;
        }

        const winMultiplier = DeadwoodRip.model.parsedGameData.currentMultiplier;
        if(winMultiplier === this._currentMultiplier) {
            return;
        }
        if(DeadwoodRip.model.parsedGameData.mode === GameMode.NORMAL && winMultiplier === 1 && this._currentMultiplier === 0) {
            return;
        }

        debugger;
        throw new Error("Displaying Multiplier doesn't match server data.");
    }

    public initFS():void {
        // this.updateMultiplier(DeadwoodRip.model.currentParsedData.currentMultiplier, false);
    }

    public resetAfterFS():void {
        if(DeadwoodRip.model.parsedGameData.betWins.length === 0) {
            this.reset();
        } else {
            this._numberText.visible = true;
            // this._numberGlowText.visible = false;
        }
    }

    public setColor(color:number, isSuper:boolean):void {
        // this._isSuper = isSuper;
        this._numberText.tint = color;
    }

    public shake():void {
        const tl = gsap.timeline();
        tl.add(gsap.to(this.scale, {x : 1.1, y : 1.1, duration : 0.2}));
        tl.add(gsap.to(this.scale, {x : 1, y : 1, duration : 0.1}));
    }
}